const TARGETING_GROUP_ID = 'C0004';

function hasMarketingConsent(): boolean {
  try {
    // OnetrustActiveGroups is a comma-separated string of active category IDs
    const groups = (window as any).OnetrustActiveGroups;
    if (typeof groups !== 'string') return false;
    return groups.split(',').includes(TARGETING_GROUP_ID);
  } catch {
    return false;
  }
}

function writeFbcIfNeeded() {
  try {
    const url = new URL(window.location.href);
    const fbclid = url.searchParams.get('fbclid');
    if (!fbclid) return;

    // Preserve first touch: don't overwrite existing _fbc
    if (document.cookie.includes('_fbc=')) return;

    const ts = Date.now(); // ms since epoch
    const fbcValue = `fb.1.${ts}.${fbclid}`;

    const maxAgeSeconds = 90 * 24 * 60 * 60; // 90 days
    let cookie = `_fbc=${encodeURIComponent(fbcValue)}; Path=/; Max-Age=${maxAgeSeconds}; SameSite=Lax`;
    if (window.location.protocol === 'https:') {
      cookie += '; Secure';
    }

    document.cookie = cookie;
  } catch (e) {
    if ((window as any).$nuxt?.$bugsnag) {
      (window as any).$nuxt.$bugsnag.notify(e, {
        context: 'fbc-plugin',
        metadata: { url: window.location.href },
      });
    }
  }
}

export default () => {
  if (typeof window === 'undefined') return;

  const tryWriteFbc = () => {
    if (hasMarketingConsent()) {
      writeFbcIfNeeded();
    }
  };

  // 1) Run once on load in case consent was already given on a previous visit
  //    (OnetrustActiveGroups is already populated)
  tryWriteFbc();

  // 2) Listen for OneTrust consent changes going forward
  //    Prefer the official API if it's available
  const oneTrust = (window as any).OneTrust;

  if (oneTrust && typeof oneTrust.OnConsentChanged === 'function') {
    oneTrust.OnConsentChanged(() => {
      tryWriteFbc();
    });
  } else {
    // Fallback: listen to the generic group update event
    window.addEventListener(
      'OneTrustGroupsUpdated',
      (event: any) => {
        const groups = event?.detail;
        if (Array.isArray(groups) && groups.includes(TARGETING_GROUP_ID)) {
          writeFbcIfNeeded();
        } else {
          // If detail isn't available, just re-check the global string
          tryWriteFbc();
        }
      },
      { once: false },
    );
  }
};
